import { useTranslation } from "react-i18next";

/**
 * HelpsCreateDiag
 *
 */
const HelpsDashboard = () => {
  const { t } = useTranslation()
  return (
    <>
      {t(
        "core:pages.osculteo.results.help.overview"
      )}
    </>
  );
};



export { HelpsDashboard };